// Single source of truth for the leadership team. Used by the Team page grid
// and by the individual profile pages (/about/team/:memberId).

const publicUrl = (import.meta.env.BASE_URL || '').replace(/\/$/, '');

export const TEAM_MEMBERS = [
  {
    slug: 'jessica-gilbertie',
    name: 'Jessica Gilbertie',
    role: 'Chief Executive Officer',
    credentials: ['MS', 'DVM', 'PhD'],
    initials: 'JG',
    accent: 'maroon',
    photo: `${publicUrl}/images/team/jessica-gilbertie.png`,
    linkedin: 'https://www.linkedin.com/in/jessica-gilbertie',
    tagline: 'Veterinary scientist and co-inventor of BIO-PLY™.',
    // Short bio used on the team grid card.
    bio:
      'Jessica is a veterinary scientist and co-inventor of BIO-PLY™. She leads Qentoros’s strategy and operations, translating peptide biology from the bench into therapies veterinarians can rely on every day.',
    // Longer, paragraph-form bio for the profile page.
    profileBio: [
      'Jessica is a veterinary scientist and co-inventor of BIO-PLY™. Her research bridges platelet biology, antimicrobial peptides, and the biofilms that make orthopedic infections so difficult to treat.',
      'As Chief Executive Officer, she leads Qentoros’s strategy and operations, translating discoveries at the bench into biologics that veterinarians can rely on in everyday practice.',
    ],
    focus: [
      {
        title: 'Platelet-derived biologics',
        body: 'Isolating and concentrating the peptide-rich fraction of platelets into a consistent, potent therapeutic.',
      },
      {
        title: 'Antimicrobial & anti-biofilm science',
        body: 'Targeting the biofilms behind refractory joint and soft-tissue infections.',
      },
      {
        title: 'Bench-to-clinic translation',
        body: 'Building cGMP manufacturing and study designs that carry lab findings into real-world care.',
      },
    ],
  },
  {
    slug: 'lauren-schnabel',
    name: 'Lauren Schnabel',
    role: 'Chief Medical Officer',
    credentials: ['DVM', 'PhD', 'DACVS', 'DACSMR'],
    initials: 'LS',
    accent: 'orange',
    photo: `${publicUrl}/images/team/lauren-schnabel.png`,
    linkedin: 'https://www.linkedin.com/in/laurenschnabelncsu',
    tagline: 'Board-certified equine surgeon and sports medicine specialist.',
    bio:
      'Lauren is a board-certified equine surgeon and sports medicine specialist. She guides clinical strategy at Qentoros, ensuring our therapies and trial designs hold up to the highest standard of veterinary care.',
    profileBio: [
      'Lauren is a board-certified equine surgeon and sports medicine specialist. She has spent her career advancing regenerative and orthopedic care for performance horses.',
      'As Chief Medical Officer, she guides clinical strategy at Qentoros, ensuring our therapies and trial designs hold up to the highest standard of veterinary medicine.',
    ],
    focus: [
      {
        title: 'Equine orthopedic surgery',
        body: 'Deep clinical experience treating the injuries and infections BIO-PLY™ is designed to address.',
      },
      {
        title: 'Regenerative & sports medicine',
        body: 'Applying biologics to return horses to soundness and athletic performance.',
      },
      {
        title: 'Clinical trial design',
        body: 'Shaping rigorous, multi-site studies that stand up to regulatory scrutiny.',
      },
    ],
  },
];

export const getTeamMember = (slug) =>
  TEAM_MEMBERS.find((member) => member.slug === slug);
